import { clientFetch, Uri } from '../utils/fetch';

import flightOnlyModel from '../models/flightOnly';

const fetchFlightOnly = async (siteSettings, userId) => {
  const { siteId, apiUrl, baseUrl, newCheckout } = siteSettings;
  const model = {
    ...flightOnlyModel,
    siteId,
    userId,
    newCheckout,
  };

  const uri = new Uri({ domain: apiUrl, path: '/api/flight', query: model });
  const response = await clientFetch.getJsonByProxy(uri, baseUrl);

  return response;
};

const fetchFlightTime = async (sessionId, homeboundTransportKey, outboundTransportKey, siteSettings) => {
  const { siteId, apiUrl, baseUrl } = siteSettings;
  const model = {
    ...flightOnlyModel,
    siteId,
    sessionId,
    homeboundTransportKey,
    outboundTransportKey,
  };

  const uri = new Uri({
    domain: apiUrl,
    path: '/api/flight/flightInformation',
    query: model,
  });
  const response = await clientFetch.getJsonByProxy(uri, baseUrl);

  return response;
};

const addFlightToCart = async (query, siteSettings) => {
  const { apiUrl, baseUrl } = siteSettings;

  const uri = new Uri({ domain: apiUrl, path: '/api/flight/addToCart', query });
  const response = await clientFetch.getJsonByProxy(uri, baseUrl);

  return response;
};

export { fetchFlightOnly, fetchFlightTime, addFlightToCart };
